import { LazyLoader } from '@bp/ui-components';
import { useAuthClaims } from 'hooks/useAuthClaims';
import { usePermissionChecker } from 'hooks/usePermissionChecker';
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import { BpPage } from '../../components/BpPage/BpPage';
import {
  DesktopNavigationTabs,
  type DesktopNavigationTabsType,
} from '../../components/NavigationTabs/Desktop/DesktopNavigationTabs';

export function InstitutionPage() {
  const { t } = useTranslation();
  const { pimAuthClaims } = useAuthClaims();
  const organization = pimAuthClaims.getOrganization();
  const perms = usePermissionChecker();

  const tabs: DesktopNavigationTabsType[] = [
    {
      title: t('common.overview'),
      path: '/institution',
      pathMatchEnd: true,
    },
    ...(perms?.canCreateProfile(organization)
      ? [
          {
            title: t('persons.title', { count: 2 }),
            path: 'persons',
          },
        ]
      : []),
    ...(perms?.canListInstitutionCourses(organization)
      ? [
          {
            title: t('courses.title'),
            path: 'courses',
          },
        ]
      : []),
    ...(perms?.canListInstitutionGroups(organization)
      ? [
          {
            title: t('groups.title'),
            path: 'groups',
          },
        ]
      : []),
    ...(perms?.canListClasses(organization)
      ? [
          {
            title: t('classes.titlePlural'),
            path: 'classes',
          },
        ]
      : []),
    ...(perms?.canListSubjects(organization)
      ? [
          {
            title: t('subjects.title', { count: 2 }),
            path: 'subjects',
          },
        ]
      : []),
    ...(perms?.canListSchoolyears(organization)
      ? [
          {
            title: t('schoolyears.title'),
            path: 'schoolyears',
          },
        ]
      : []),
  ];

  return (
    <BpPage title={t('institution.myInstitution')} isForbidden={false}>
      <DesktopNavigationTabs tabs={tabs} className='mb-6' />
      <Suspense fallback={<LazyLoader embedded transparent forceHeight='45vh' />}>{<Outlet />}</Suspense>
    </BpPage>
  );
}
